import React from 'react';
import { Col, Row } from 'antd';
import { I18n } from '@aws-amplify/core';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import 'moment/locale/pt-br';

import * as S from './styles';

interface ModalSaveAnswersProps {
	toggleModal: () => void;
	isOpen: boolean;
}

export function ModalSaveAnswers({ isOpen, toggleModal }: Readonly<ModalSaveAnswersProps>): JSX.Element {
	return (
		<S.SmallModalStyled width={400} footer={null} open={isOpen} onCancel={toggleModal} centered>
			<Row gutter={[64, 48]} justify="center">
				<Col span={24}>
					<Row justify="center" gutter={[16, 24]}>
						<Col style={{ marginBottom: '0rem', marginTop: '1rem' }}>
							<ExclamationCircleOutlined
								style={{
									fontSize: '4rem',
									color: '#002FBB'
								}}
							/>
						</Col>
						<S.CustomCol span={24}>
							<S.AlertContentText>{I18n.get('Your answers have been saved')}</S.AlertContentText>
						</S.CustomCol>
					</Row>
				</Col>
				<Row gutter={[32, 32]}>
					<Col span={24} style={{ display: 'flex', justifyContent: 'center', alignItems: 'flex-end' }}>
						<S.RoundButton key="back" onClick={toggleModal} type="primary">
							{I18n.get('Close')}
						</S.RoundButton>
					</Col>
				</Row>
			</Row>
		</S.SmallModalStyled>
	);
}
